import React, { useEffect, useState } from 'react';
import DateInput from '../components/DateInput';
import api from '../api/axios';
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';

const fmtDate = d => d ? format(new Date(d), 'dd/MM/yyyy') : '—';

export default function Reconciliation() {
  const [data, setData] = useState({ indent_pending:[], under_sea:[], at_port:[], other:[] });
  const [filters, setFilters] = useState({ date_from:'', date_to:'', shipper:'', quality:'', origin:'' });
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const load = async () => {
    setLoading(true);
    const params = Object.fromEntries(Object.entries(filters).filter(([,v])=>v));
    const r = await api.get('/reconciliation', { params });
    setData(r.data);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const Section = ({ title, items, color }) => (
    <div className="card mb-2">
      <div className="section-title" style={{color}}>{title} <span className="badge badge-gray">{items.length}</span></div>
      {items.length === 0 ? <div className="empty-state" style={{padding:'16px'}}>No orders in this category</div> :
        <div className="table-wrap">
          <table>
            <thead><tr><th>Order No</th><th>BL No</th><th>Shipper</th><th>Quality</th><th>Origin</th><th>BL Date</th><th>Bill Wt</th><th>Due Date</th><th>Port Status</th></tr></thead>
            <tbody>
              {items.map(r => (
                <tr key={r.shipment_id} style={{cursor:'pointer'}} onClick={()=>navigate(`/orders/${r.order_id}`)}>
                  <td className="fw-bold text-primary">{r.order_no}</td>
                  <td>{r.bl_no||'—'}</td>
                  <td>{r.shipper_name}</td>
                  <td>{r.quality}</td>
                  <td>{r.origin_country}</td>
                  <td>{fmtDate(r.date_of_bl)}</td>
                  <td>{r.bill_weight_mt ? `${r.bill_weight_mt} MT` : '—'}</td>
                  <td style={{color: r.due_date && new Date(r.due_date)<new Date() ? 'var(--accent)' : 'inherit'}}>{fmtDate(r.due_date)}</td>
                  <td>{r.port_status ? <span className="badge badge-blue">{r.port_status}</span> : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      }
    </div>
  );

  return (
    <div>
      <div className="page-header">
        <div><h2>Reconciliation Board</h2><p>Live view of all active shipments by status</p></div>
      </div>
      <div className="filter-bar">
        <div className="form-group"><label>Shipper</label><input className="form-control" value={filters.shipper} onChange={e=>setFilters({...filters,shipper:e.target.value})} /></div>
        <div className="form-group"><label>Quality</label><input className="form-control" value={filters.quality} onChange={e=>setFilters({...filters,quality:e.target.value})} /></div>
        <div className="form-group"><label>Origin</label><input className="form-control" value={filters.origin} onChange={e=>setFilters({...filters,origin:e.target.value})} /></div>
        <div className="form-group"><label>From</label><DateInput className="form-control" value={filters.date_from} onChange={e=>setFilters({...filters,date_from:e.target.value})} /></div>
        <div className="form-group"><label>To</label><DateInput className="form-control" value={filters.date_to} onChange={e=>setFilters({...filters,date_to:e.target.value})} /></div>
        <button className="btn btn-primary btn-sm" onClick={load}>Apply</button>
        <button className="btn btn-secondary btn-sm" onClick={()=>{ setFilters({date_from:'',date_to:'',shipper:'',quality:'',origin:''}); setTimeout(load,50); }}>Clear</button>
      </div>
      {loading ? <div className="loading">Loading...</div> : <>
        <Section title="(A) Indent Documents Not Yet Received" items={data.indent_pending} color="var(--warning)" />
        <Section title="(B) Material Under Sea / On Ship" items={data.under_sea} color="var(--info)" />
        <Section title="(C) Material at Port / In Customs" items={data.at_port} color="var(--accent)" />
        {data.other?.length > 0 && <Section title="(D) Other Active Shipments" items={data.other} color="var(--text-muted)" />}
      </>}
    </div>
  );
}
